"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_service_1 = require("./api-service");
var CommissionService = /** @class */ (function (_super) {
    __extends(CommissionService, _super);
    function CommissionService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'commissions';
        return _this;
    }
    CommissionService.prototype.representatives = function (params) {
        return this.getCollectionRequest(this.url('representatives'), { params: params });
    };
    CommissionService.prototype.createRepresentative = function (representative) {
        return this.postRequest(this.url('representatives'), representative);
    };
    CommissionService.prototype.getRepresentative = function (id) {
        return this.getRequest(this.url('representatives', id));
    };
    CommissionService.prototype.updateRepresentative = function (id, representative) {
        return this.putRequest(this.url('representatives', id), representative);
    };
    CommissionService.prototype.deleteRepresentative = function (id) {
        return this.deleteRequest(this.url('representatives', id));
    };
    CommissionService.prototype.commissions = function (params) {
        return this.getCollectionRequest(this.url('commissions'), { params: params });
    };
    CommissionService.prototype.getCommission = function (id) {
        return this.getRequest(this.url('commissions', id));
    };
    CommissionService.prototype.revokeCommission = function (id) {
        return this.patchRequest(this.url('commissions', id, 'revoke'), null);
    };
    CommissionService.prototype.approveCommission = function (id) {
        return this.patchRequest(this.url('commissions', id, 'approve'), null);
    };
    CommissionService.prototype.unapproveCommission = function (id) {
        return this.patchRequest(this.url('commissions', id, 'unapprove'), null);
    };
    CommissionService.prototype.recalculateCommission = function (id, commission) {
        return this.patchRequest(this.url('commissions', id, 'recalculate'), commission);
    };
    CommissionService.prototype.massApproveCommission = function (ids) {
        return this.patchRequest(this.url('commissions', 'approve'), { ids: ids });
    };
    CommissionService.prototype.massUnapproveCommission = function (ids) {
        return this.patchRequest(this.url('commissions', 'unapprove'), { ids: ids });
    };
    CommissionService.prototype.massRecalculateCommission = function (data) {
        return this.patchRequest(this.url('commissions', 'recalculate'), data);
    };
    return CommissionService;
}(api_service_1.ApiService));
exports.default = CommissionService;
//# sourceMappingURL=commission-service.js.map